import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { ButtonVariant } from '../../types/ButtonVariant';
import { SharedButtonProps } from '../../types/SharedButtonProps';
import { useModal } from './useModal';

type Callback = () => void;

interface Props {
  children: React.ReactNode;
  title: string;
  onDelete: () => void;
  isDeleting?: boolean;
  secondaryActions?: SharedButtonProps[];
  primaryActionText?: string;
}

export const useDeleteModal = ({
  children,
  isDeleting,
  secondaryActions,
  title,
  onDelete,
  primaryActionText,
}: Props): [React.ReactNode, Callback, Callback] => {
  const intl = useIntl();
  const props = useMemo(
    () => ({
      children,
      primaryAction: {
        isLoading: isDeleting,
        text:
          primaryActionText ||
          intl.formatMessage({
            id: 'UseDeleteModal.deleteAction',
            defaultMessage: 'Delete',
            description: 'Label for modal action delete',
          }),
        variant: 'danger' as ButtonVariant,
        onClick: onDelete,
      },
      secondaryActions,
      title,
    }),
    [children, isDeleting, secondaryActions, title],
  );

  return useModal(props);
};
